export * from './deletion-scheduled/service-object-status-deletion-scheduled';
export * from './restorable/service-object-status-restorable';
export * from './deleting/service-object-status-deleting';

import './service-object-status.scss';
